const CustomGrid = ({ children, extraClassName }) => {
    return (
        <div className={`grid ${extraClassName || ""}`}>
            {children}
        </div>
    )
}

export default CustomGrid